import React, { FunctionComponent } from 'react';
import { PrimaryLinkModel, SecondaryLinkModel } from '../../models/navigationItem.model';
import RoutableSitecoreLink from '../../../@shared/routableSitecoreLink';
import MenuLink from './menuLink';
import { isEditorActive, Text } from '@sitecore-jss/sitecore-jss-react';
import useEEActive from '../../../../hooks/useEEActive';
import { googleNavClickEvent } from '../../../../utils/analytics';
import { topMainMenu } from '../../../../constants/analytics.constants';

const PrimaryLink: FunctionComponent<{ model: PrimaryLinkModel; onClick?: () => void }> = ({ model, onClick }) => {
  const isEE = useEEActive();
  if (model.hasSecondaryLinks) {
    return (
      <div className={'navigation-link navigation-link--primary navigation-link--has-secondary'}>
        {(isEE || model.link) && (
          <RoutableSitecoreLink
            field={model.link}
            className="navigation-link__main-anchor"
            onClick={() => {
              onClick && onClick();
              googleNavClickEvent(topMainMenu, model?.link?.value?.href, model?.link?.value?.text || model?.link?.value?.title);
            }}
          />
        )}
        {model.secondaryLinks.map((secondaryLink) => (
          <MenuLink
            model={secondaryLink}
            key={(secondaryLink as SecondaryLinkModel)?.id}
            onClick={() => {
              onClick && onClick();
              const model = secondaryLink as SecondaryLinkModel;
              googleNavClickEvent(topMainMenu, model.link?.value?.href, model.link?.value?.title);
            }}
          />
        ))}
        {isEditorActive() ? (
          <Text className="navigation-link__anchor" tag="span" field={model.viewAll} />
        ) : (
          model.hasViewAll && (
            <RoutableSitecoreLink
              field={{ ...model.link, value: { ...model.link.value, text: model.viewAllText } }}
              className="navigation-link__view-all"
              text={'View all'}
              onClick={onClick}
            />
          )
        )}
      </div>
    );
  }
  return (
    (isEE || model.link) && (
      <RoutableSitecoreLink
        field={model.link}
        className="navigation-link navigation-link--primary"
        onClick={() => {
          onClick && onClick();
          googleNavClickEvent(topMainMenu, model?.link?.value?.href, model?.link?.value?.text || model?.link?.value?.title);
        }}
      />
    )
  );
};

export default PrimaryLink;
